import script from "./BrandMarquee.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrandMarquee.vue?vue&type=script&setup=true&lang=ts"

import "./BrandMarquee.vue?vue&type=style&index=0&id=69e979ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69e979ae"]])

export default __exports__